import { Route } from '@angular/router';
import { MainLayoutComponent } from './core/layout/main-layout/main-layout.component';
import { isAuthenticatedGuard } from './shared/guard/is-authenticated.guard';
import { IsNotAuthenticatedGuard } from './shared/guard/is-not-authenticated.guard';

export const appRoutes: Route[] = [
  {
    path: 'auth',
    canActivate: [IsNotAuthenticatedGuard()],
    loadChildren: () =>
      import('./page/auth/auth.routes').then(m => m.authRoutes),
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [],
    children: [
      {
        path: '',
        redirectTo: 'welcome-screen-start',
        pathMatch: 'full',
      },
      {
        path: '',
        loadChildren: () =>
          import('./page/main/main.routes').then(m => m.routes),
      },
      {
        path: 'help',
        loadChildren: () =>
          import('./page/util-views/util-views.routes').then(m => m.routes),
      },
      {
        path: 'settings',
        canActivate: [isAuthenticatedGuard()],
        loadChildren: () =>
          import('./page/settings/settings.routes').then(m => m.routes),
      },
      {
        path: 'questionnaire',
        loadChildren: () =>
          import('./page/questionnaire/questionnaire.routes').then(
            m => m.routes
          ),
      },
    ],
  },
];
